import { Route } from "src/shared/constants/route";
import { Permission } from "src/shared/contexts/PermissionsContext/types";

import { TSidebarItem } from "./sections";

type TSidebarVisibilityContext = {
  isOrganizer: boolean;
  statusOnlyHacker: boolean;
  canAccessPostRsvpTools: boolean;
  canAccessTravelSupport: boolean;
  canAccessHardware: boolean;
  canAccessJudging: boolean;
  hasPermission: (permission: Permission) => boolean;
};

export const canViewSidebarItem = (
  item: TSidebarItem,
  {
    isOrganizer,
    statusOnlyHacker,
    canAccessPostRsvpTools,
    canAccessTravelSupport,
    canAccessHardware,
    canAccessJudging,
    hasPermission,
  }: TSidebarVisibilityContext
) => {
  if (isOrganizer) return true;

  if (item.requiresTravelSupportBot && !canAccessTravelSupport) return false;

  if (item.requiresHardwareOpen && !canAccessHardware) return false;

  if (item.requiresJudgingOpen && !canAccessJudging) return false;

  if (
    statusOnlyHacker &&
    ![
      Route.HACKER_RSVP,
      Route.HACKER_TRAVEL_SUPPORT,
      Route.BADGE_MY_BADGE,
    ].includes(item.href)
  ) {
    return false;
  }

  if (
    item.requiresHackerPostRsvpTools &&
    item.href !== Route.HACKER_DIRECTORY_DIRECTORY &&
    !canAccessPostRsvpTools
  ) {
    return false;
  }

  const canAccess =
    !item.permissions ||
    item.permissions.length === 0 ||
    item.permissions.some((permission) => hasPermission(permission));

  if (item.antiPermissions?.some((permission) => hasPermission(permission))) {
    return false;
  }

  return canAccess;
};
